var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon blueSVGs",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_7125_30701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calendar_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0476 1.16602H15.059C15.579 1.16602 16 1.53502 16 1.98797V13.8213C16 14.2763 15.579 14.6433 15.059 14.6433H0.940952C0.420952 14.6433 0 14.2743 0 13.8213V1.98797C0 1.53306 0.420952 1.16602 0.940952 1.16602H3.04762",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0476 1.16602H15.059C15.579 1.16602 16 1.53502 16 1.98797V13.8213C16 14.2763 15.579 14.6433 15.059 14.6433H0.940952C0.420952 14.6433 0 14.2743 0 13.8213V1.98797C0 1.53306 0.420952 1.16602 0.940952 1.16602H3.04762",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.57422 1.16602H11.5266",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0 4.16016H16",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M4.04687 0H3.57068C3.28139 0 3.04688 0.24038 3.04688 0.536905V2.12614C3.04688 2.42267 3.28139 2.66305 3.57068 2.66305H4.04687C4.33617 2.66305 4.57068 2.42267 4.57068 2.12614V0.536905C4.57068 0.24038 4.33617 0 4.04687 0Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M12.5234 0.0839844H12.0472C11.758 0.0839844 11.5234 0.324365 11.5234 0.620889V2.21013C11.5234 2.50665 11.758 2.74703 12.0472 2.74703H12.5234C12.8127 2.74703 13.0472 2.50665 13.0472 2.21013V0.620889C13.0472 0.324365 12.8127 0.0839844 12.5234 0.0839844Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5779 12.5639H2.95312V5.9082H13.0484V10.4006",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5779 12.5639H2.95312V5.9082H13.0484V10.4006",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M5.61914 6.07617V12.5659",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M8.09375 6.07617V12.5659",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M10.5703 6.07617V12.5659",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M12.9521 8.23828H3.14258",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M12.9521 10.4004H3.14258",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M8.1901 8.1543H5.52344V10.3175H8.1901V8.1543Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7125_30701"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/CalenderIcon.390986ec357b12f696529b799ce7b59a.svg";
export { ForwardRef as ReactComponent };